/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** @module core/modules/object-utils/get-keys */
import { isObject } from './is-object.js';
/**
 * @description Returns an array with all input obtainable keys.
 * @param {*} input - Input value.
 * @returns {Array<*>} Keys array.
 */

function getKeys(input) {
  var _this = this;

  if (_Array$isArray(input)) {
    var _context, _context2;

    return _mapInstanceProperty(_context = _Object$keys(input)).call(_context, _bindInstanceProperty(_context2 = function _context2(a) {
      _newArrowCheck(this, _this);

      return _parseInt(a);
    }).call(_context2, this));
  } else if (isObject(input)) {
    return _Object$getOwnPropertyNames(input);
  } else {
    return [];
  }
}

export { getKeys };